import _ from "lodash";
import parseImageId from "./parseImageId";
import loadFileRequest from "./loadFileRequest.js";
import { xhrRequest } from "../internal/index.js";
import Cache from "core/cache/index";
import Loader from "core/loader/index";
import Memory from "core/performance";
import Helper from "helper/index";
import Config from "config";
import FloatMessageBox from "core/messageBoxController/index";
import LoadingSnackbarManager from "component/atoms/loadingSnackbar/loadingSnackbarManager";

function isLoadComplete(loadedFiles, totalFiles) {
  if (loadedFiles === totalFiles) {
    //LoadingSnackbarManager.complete("Complete", 3000);
    return true;
  }
  return false;
}

function getLoaderForScheme(scheme) {
  if (scheme === "dicomweb" || scheme === "wadouri") {
    return xhrRequest;
  } else if (scheme === "dicomfile") {
    return loadFileRequest;
  }
}

async function get(urls, options) {
  ///
  /// 0. 입력 데이터가 없다면, 함수를 종료
  ///
  const totalFiles = urls.length;
  if (totalFiles === 0) {
    return;
  }
  /**
   * 1. Check memory
   * @ref @site : https://stackoverflow.com/questions/23506064/how-do-you-detect-memory-limits-in-javascript
   */
  const hasFreeMemory = Memory.hasFreeMemoryCapacity(30000000 /**30mb */);

  if (hasFreeMemory === false) {
    FloatMessageBox({
      title: "Warning",
      message:
        "The data cannot be loaded.\r\n The memory usage has reached the limit.",
    });
    return;
  }

  LoadingSnackbarManager.loading("Loading", -1);
  var t0 = performance.now();

  let loadedFiles = 0;
  const chunckSize = 20;
  const cacheChunks = new Array(Math.ceil(urls.length / chunckSize))
    .fill()
    .map((_) => {
      return urls.splice(0, chunckSize);
    });
  for (let chunk of cacheChunks) {
    //console.log("wait");
    await Promise.all(
      // eslint-disable-next-line no-loop-func
      chunk.map(async function (url) {
        const parsedURL = parseImageId(url);
        const loader = getLoaderForScheme(parsedURL.scheme);
        const loadDICOMPromise = loader(parsedURL.url, url);

        try {
          await loadDICOMPromise.then(function (
            dicomPart10AsArrayBuffer /* , xhr*/
          ) {
            // console.log("b")
            // for pacs
            dicomPart10AsArrayBuffer = dicomPart10AsArrayBuffer.slice(182, -41);
            // console.log("a", dicomPart10AsArrayBuffer)
            setTimeout(function () {
              try {
                let dicomLoader = new Loader.LoaderDicom();
                dicomLoader
                  .parseFile(parsedURL.url, dicomPart10AsArrayBuffer)
                  .then(function (data) {
                    let metadataCache = new Cache.Metadata();
                    const seriesInstanceUID = data.seriesInstanceUID;
                    const modality = data.modality;
                    if (
                      !Helper.Validator.isString(seriesInstanceUID) ||
                      !Helper.Validator.isString(modality)
                    ) {
                      console.error(
                        "DICOM Data Type is not correct : seriesInstanceUID or modality"
                      );
                      return;
                    }

                    metadataCache.add(seriesInstanceUID, modality, data);
                  })
                  .catch(function (err) {
                    console.error(err);
                  })
                  .finally(() => {
                    loadedFiles += 1;
                    if (isLoadComplete(loadedFiles, totalFiles)) {
                      LoadingSnackbarManager.complete("Complete", 3000);
                      Config.rootStore.seriesListStore.updateThumbnails();

                      var t2 = performance.now();
                      // console.log(
                      //   "SingleThread loading Complete " +
                      //     (t2 - t0) / 1000 +
                      //     " sec"
                      // );
                    }
                  });
              } catch (ex) {
                console.log("Exception load");
                const parameters = {
                  title: "Warning",
                  message: "This data is not supported format",
                  buttonType: "OK",
                  hasCloseButton: false,
                  hasTodayOffButton: false,
                };
                FloatMessageBox(parameters);
                loadedFiles += 1;
                if (isLoadComplete(loadedFiles, totalFiles)) {
                  LoadingSnackbarManager.complete("Complete", 3000);
                  Config.rootStore.seriesListStore.updateThumbnails();

                  var t2 = performance.now();
                  // console.log(
                  //   "SingleThread loading Complete " + (t2 - t0) / 1000 + " sec"
                  // );
                }
              }
            }, 0);
          });
        } catch (ex) {
          loadedFiles += 1;
          if (isLoadComplete(loadedFiles, totalFiles)) {
            LoadingSnackbarManager.complete("Complete", 3000);
            Config.rootStore.seriesListStore.updateThumbnails();

            var t2 = performance.now();
            //console.log("Call to comp took " + (t2 - t0) / 1000 + " sec");
          }
        }
      })
    ).then(() => {
      var t2 = performance.now();
      //console.log("Call to comp2 took " + (t2 - t0) / 1000 + " sec");
    });
  }
}

const WadoURIProvider = {
  get,
};
export default WadoURIProvider;
